import React from 'react';
import { GetServerSideProps } from 'next';
import Head from 'next/head';

import AppContainer from '~/containers/AppContainer/AppContainer';
import { getTradeCountries } from '~/networking/api/cms/requests/getTradeCountries';
import type { CMSTradeCountries } from '~/networking/api/cms/responses/CMSRegion';
import HeaderMetaTags from '~/components/modules/Header/HeaderMetaTags';
import { CountryDirectory } from '~/components/views/Directory/CountryDirectory';
import { useRouter } from 'next/router';

interface Props {
    countries: CMSTradeCountries;
}

const CountryListPage: React.FC<Props> = (props) => {
    const { countries } = props;
    const router = useRouter();
    return (
        <AppContainer>
            <Head>
                <meta name={'googlebot'} content={'noindex'} />
            </Head>
            <HeaderMetaTags
                url={`${process.env.NEXT_PUBLIC_HOST_ENV}${router.asPath}`}
                title={'Top Wine Producing Countries - Wine Investing | Vinovest'}
                description={`Browse through Vinovest's top wine producing countries to help inform you of your next investments on Vinovest.`}
                canonical
            />
            <CountryDirectory countries={countries} />
        </AppContainer>
    );
};

export default CountryListPage;

export const getServerSideProps: GetServerSideProps = async () => {
    const response = await getTradeCountries();
    if (!response.data || response.status !== 200) {
        throw new Error(`Failed to fetch trade countries ${response.statusText}`);
    }

    return {
        props: {
            countries: response.data
        }
    };
};
